import { CSSProperties, SyntheticEvent, VFC } from "react";
// Libraries
import SVG from "react-inlinesvg";
// Resources
import styles from "./ImageButton.module.scss";

interface ImageButtonBase {
  backgroundColour?: string;
  fallbackText: string;
  onClick?: (event?: SyntheticEvent<HTMLButtonElement>) => void;
}

interface ImageButtonWithIcon extends ImageButtonBase {
  icon: string;
  image?: never;
}

interface ImageButtonWithImage extends ImageButtonBase {
  icon?: never;
  // `image` is optional because the source could be a query that is still loading
  image?: string;
}

type ImageButtonProps = ImageButtonWithIcon | ImageButtonWithImage;

export const ImageButton: VFC<ImageButtonProps> = ({ backgroundColour, fallbackText, icon, image, onClick }) => {
  const buttonStyle: CSSProperties = {};
  if (backgroundColour) buttonStyle.backgroundColor = backgroundColour;
  if (image) buttonStyle.backgroundImage = `url(${image})`;

  const firstLetter = fallbackText.charAt(0);

  const canShowFallbackText = !icon && !image;

  return (
    <button className={styles.image_button} onClick={onClick} style={buttonStyle} type="button">
      {icon && <SVG className={styles.image_button__icon} src={icon} />}

      {canShowFallbackText && <span className={styles.image_button__caption}>{firstLetter}</span>}
    </button>
  );
};
